var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 37,
    viewBox: "0 0 174 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.838 18.3031C13.6397 18.3031 15.9069 19.1326 17.6395 20.7915C19.409 22.4503 20.2937 24.5516 20.2937 27.0952C20.2937 29.5283 19.4274 31.6664 17.6948 33.5096C15.9622 35.3159 13.8609 36.2191 11.391 36.2191H0V28.9753L10.6169 29.0306C11.0961 29.0306 11.5016 28.8463 11.8334 28.4776C12.1652 28.0721 12.331 27.6113 12.331 27.0952C12.331 26.063 11.6306 25.5469 10.2298 25.5469C7.39125 25.5469 5.03195 24.6069 3.15188 22.7268C1.30868 20.8468 0.387073 18.5796 0.387073 15.9254C0.387073 13.603 1.32711 11.5754 3.20718 9.84282C5.08725 8.1102 7.2438 7.2439 9.67683 7.2439H27.5928L20.0172 14.8195L9.40035 14.7642C8.95798 14.7642 8.55247 14.8932 8.18383 15.1513C7.85206 15.3724 7.68617 15.7226 7.68617 16.2019C7.68617 17.0129 7.96265 17.5659 8.51561 17.8608C9.21603 18.1557 9.99017 18.3031 10.838 18.3031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9895 14.7089L37.9522 7.2439V36.2191H29.9895V14.7089ZM22.6904 14.7642L30.2107 7.2439H48.0161L40.4958 14.7642H22.6904Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7439 24.4409L67.1848 0H75.811V36.219H65.8577V31.5741H50.1536L59.0563 22.7267H65.8577V13.1052L42.7439 36.219V24.4409Z",
    fill: "url(#paint0_linear_145_1843)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1667 9.95331L88.12 0V36.219H78.1667V9.95331ZM97.7415 0C101.428 0 104.359 0.958467 106.534 2.8754C108.709 4.75547 109.796 7.59401 109.796 11.391C109.796 14.6351 108.709 17.3446 106.534 19.5196C104.396 21.6577 101.557 22.7267 98.018 22.7267C96.4697 22.7267 95.6956 22.5793 95.6956 22.2844L95.9168 22.0632L96.525 21.7867L90.6083 17.2524L95.0873 17.1971C96.5619 17.1971 97.6862 16.81 98.4604 16.0359C99.2345 15.2617 99.6216 14.2848 99.6216 13.1052C99.6216 11.9255 99.2714 11.0039 98.571 10.3404C97.9074 9.67683 96.7462 9.34505 95.0873 9.34505L88.12 9.40035V0H97.7415ZM109.52 36.4955L90.2766 17.2524H102.055L109.52 24.8833V36.4955Z",
    fill: "url(#paint1_linear_145_1843)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.172 9.28976L131.125 0V36.219H121.172V9.28976ZM112.048 9.40035L121.448 0H143.733L134.332 9.40035H112.048Z",
    fill: "url(#paint2_linear_145_1843)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.411 26.8187L156.93 7.2439H163.787V36.2191H155.824V32.5142H143.272L150.405 25.4363H155.824V17.7502L137.411 36.2191V26.8187Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.037 15.2065L174 7.2439V36.2191H166.037V15.2065Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_145_1843",
    x1: 143.77,
    y1: 36.4955,
    x2: 42.8545,
    y2: 0.0000162002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A95EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_145_1843",
    x1: 143.77,
    y1: 36.4955,
    x2: 42.8545,
    y2: 0.0000162002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A95EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_145_1843",
    x1: 143.77,
    y1: 36.4955,
    x2: 42.8545,
    y2: 0.0000162002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A95EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/WhiteLogo.40393d413e8fd7291a9a5042856242b3.svg";
export { ForwardRef as ReactComponent };